/**
 * JavaScript functions for auctions.
 */

jQuery( $ => {
	$( '.woocommerce-form-register #billing_country' ).select2();
	$( '.woocommerce-MyAccount-content #billing_country' ).select2();
} );
